(function () {
  const legacyPacks = {
    '53829877793034': 2,
    '53829945852170': 4,
    '53829945884938': 6
  };
  let migrating = false;

  async function jsonRequest(url, options) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...options
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Nie udało się zaktualizować koszyka.');
    }
    return data;
  }

  function prepareUpdates(cart, variantMap) {
    const updates = {};
    const quantities = new Map();
    const existing = new Map();

    for (const item of cart.items) {
      if (!legacyPacks[String(item.variant_id)] && !item.properties) {
        existing.set(String(item.variant_id), item);
      } else if (!legacyPacks[String(item.variant_id)] && Object.keys(item.properties || {}).length === 0) {
        existing.set(String(item.variant_id), item);
      }
    }

    for (const item of cart.items) {
      const pieces = legacyPacks[String(item.variant_id)];
      if (!pieces) continue;
      const lookup = variantMap[String(pieces)] || {};
      const additions = [];

      for (let position = 1; position <= pieces; position += 1) {
        const size = item.properties?.['_Rozmiar ' + position];
        const color = item.properties?.['_Kolor ' + position];
        const variantId = Number(lookup[color + '|' + size]);
        if (!size || !color || !Number.isSafeInteger(variantId) || variantId <= 0) {
          additions.length = 0;
          break;
        }
        additions.push(variantId);
      }

      if (additions.length !== pieces) continue;
      updates[item.key] = 0;
      for (const variantId of additions) {
        const id = String(variantId);
        quantities.set(id, (quantities.get(id) || 0) + item.quantity);
      }
    }

    for (const [variantId, extraQuantity] of quantities) {
      const line = existing.get(variantId);
      updates[line ? line.key : variantId] = (line ? line.quantity : 0) + extraQuantity;
    }
    return { updates, migratedCount: Object.values(updates).filter((quantity) => quantity === 0).length };
  }

  async function migrate() {
    if (migrating || !document.querySelector('.cart-drawer-item--zaveli-pack')) return;
    const mapNode = document.getElementById('ZaveliCartVariantMap');
    if (!mapNode) return;

    let variantMap;
    try {
      variantMap = JSON.parse(mapNode.textContent);
    } catch (error) {
      return;
    }

    migrating = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await jsonRequest(root + 'cart.js');
      const { updates, migratedCount } = prepareUpdates(cart, variantMap);
      if (!migratedCount) return;

      const drawer = document.querySelector('cart-drawer');
      const wasOpen = drawer?.classList.contains('active') || false;
      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.section || section.id).filter(Boolean).slice(0, 5)
        : [];
      const updatedCart = await jsonRequest(root + 'cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          updates,
          sections,
          sections_url: window.location.pathname + window.location.search
        })
      });

      if (updatedCart.items.some((item) => legacyPacks[String(item.variant_id)] && updates[item.key] === 0)) {
        throw new Error('Nie udało się rozdzielić zestawu.');
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (wasOpen && updatedCart.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(updatedCart);
      } else {
        
        const html=updatedCart.sections?.['cart-drawer'];const replacement=html&&new DOMParser().parseFromString(html,'text/html').querySelector('cart-drawer');if(drawer&&replacement){drawer.innerHTML=replacement.innerHTML;drawer.classList.toggle('is-empty',replacement.classList.contains('is-empty'));}
      }
    } catch (error) {
      console.error('Zaveli cart migration:', error);
    } finally {
      migrating = false;
    }
  }

  function init() {
    if (sessionStorage.getItem('zaveli-reopen-cart') === '1') {
      sessionStorage.removeItem('zaveli-reopen-cart');
      customElements.whenDefined('cart-drawer').then(function () {
        document.querySelector('cart-drawer')?.open();
      });
    }
    migrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

